import { render, staticRenderFns } from "./CourseEditor.vue?vue&type=template&id=08b45ae9"
import script from "./CourseEditor.vue?vue&type=script&lang=js"
export * from "./CourseEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports